import React, {useMemo} from 'react';
import styled from 'styled-components';
import {formBodyType} from '../../../../../../util/uiconstants';
import {useAresUrlParameters} from '../../../../../../util/Ares/customHooks';
import TaskDetailsV2 from '../../../../../Main/Ares/Tasks/TaskView/V2/TaskDetailsV2';
import TrackChangesNotAvailableMessageContainer from '../../../../TrackChanges/TrackChangesNotAvailableMessageContainer';

export default function SummaryBody() {
	const {taskId, documentId} = useAresUrlParameters();

	const taskDetailRender = useMemo(() => {
		return (
			<TaskDetailsV2 key={taskId} taskId={taskId} documentId={documentId} headersAreLoading={false} isSummaryBody />
		);
	}, [taskId, documentId]);

	return (
		<StyledSummaryBody className="StyledSummaryBody">
			<TrackChangesNotAvailableMessageContainer bodyTypeId={formBodyType.Summary} />
			{taskDetailRender}
		</StyledSummaryBody>
	);
}

const StyledSummaryBody = styled.section``;
